exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page-fathersday-rule .main[data-v-f571d00a] {\n  background: #fde1c0;\n  border-radius: 3px;\n  padding: 15px;\n}\n.page-fathersday-rule .main .textcontent[data-v-f571d00a] {\n  background-color: #fff;\n  border-radius: 3px;\n  border: 0.5px solid #f79a2c;\n}\n.page-fathersday-rule .main h3[data-v-f571d00a] {\n  padding: 10px 0;\n  text-align: center;\n  border-bottom: 5px solid #fde1c0;\n  color: #454545;\n}\n.page-fathersday-rule .main .content[data-v-f571d00a] {\n  padding: 20px;\n}\n", ""]);

// exports
